/* SYDZ - bande de videos clients.

   Meme mecanisme que le site publie : les clips se lancent seuls quand ils
   entrent dans le champ et se mettent en pause quand ils en sortent. Aucun
   bouton a presser.

   Trois conditions sans lesquelles un navigateur refuse la lecture automatique,
   et qui doivent rester dans le gabarit : `muted`, `playsinline`, et un `src`
   deja pose. `preload="metadata"` ne telecharge que l'en-tete : l'image
   d'attente reste affichee et rien n'est a recharger quand la vignette revient.

   La pause hors champ n'est pas un detail : une video qui tourne sans etre vue
   consomme de la batterie et du forfait pour rien, sur un trafic qui vient
   presque entierement du telephone.

   Element personnalise, pour que l'editeur de theme demonte proprement et que
   rien ne s'attache deux fois au rechargement d'une section. */
(function () {
  'use strict';

  var Ugc = class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.next = this.querySelector('[data-next]');
      if (!this.rail) return;

      this.sobre = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.videos = Array.prototype.slice.call(this.querySelectorAll('video'));

      this.onNext = this.advance.bind(this);
      this.onScroll = this.sync.bind(this);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });

      var self = this;
      this.obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var v = e.target;
          var hote = v.closest('[data-item]');
          if (e.isIntersecting && !self.sobre.matches) {
            var p = v.play();
            /* Refus de lecture automatique (economie d'energie, politique du
               navigateur) : l'image d'attente reste, la bande garde du sens. */
            if (p && p.catch) p.catch(function () {});
            if (hote) hote.dataset.playing = 'true';
          } else {
            v.pause();
            if (hote) hote.dataset.playing = 'false';
          }
        });
      }, { threshold: 0.35 });

      this.videos.forEach(function (v) { self.obs.observe(v); });
      this.sync();
    }

    disconnectedCallback() {
      if (this.obs) this.obs.disconnect();
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.rail) this.rail.removeEventListener('scroll', this.onScroll);
      this.videos.forEach(function (v) { v.pause(); });
    }

    advance() {
      var first = this.rail.firstElementChild;
      if (!first) return;
      this.rail.scrollBy({
        left: first.offsetWidth + 12,
        behavior: this.sobre.matches ? 'auto' : 'smooth'
      });
    }

    sync() {
      if (!this.next) return;
      var fin = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      this.next.disabled = fin;
    }
  };

  if (!customElements.get('sydzm-ugc')) customElements.define('sydzm-ugc', Ugc);
})();
